module.exports = __webpack_public_path__ + "img/christian-post.0102b566.svg";